<div class="text-center mt-5">
  <i class="fa fa-exclamation-triangle text-warning mb-3" style="font-size: 3rem;"></i>
  <h2 class="text-danger">404 - Page Not Found</h2>
  <p class="text-muted">The page you entered does not exist. Please check the URL and try again.</p>
  <a routerLink="/logs" class="btn btn-outline-primary btn-sm mt-3">
    <i class="fa fa-home me-2"></i> Go to Home
  </a>
</div>
